import * as React from "react";
import { Helmet } from "react-helmet";
import { fetchData } from '../utils'
import * as AuthStore from "../store/Auth";
import { ApplicationState } from '../store';
import { connect } from "react-redux";
import { Table, Button, Select, Tabs, Row, Col, message } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
const { Option } = Select;
const { TabPane } = Tabs;

type AuthProps =
    AuthStore.AuthState // ... state we've requested from the Redux store
    & typeof AuthStore.actionCreators // ... plus action creators we've requested

class MissedAppointment extends React.Component<AuthProps>
{
    public state =
    {
        buttonText: 'Add',
        ltfu1: [],
        ltfu2: [],
        ltfu3: [],
        ltfu4: [],
        ltfu5: [],
        ltfu6: [],
        ltfu7: [],
        states: [],
            sites: [],
            pagination:
            {
                current: 1,
                total: 0,
                pageSize: 100,
                sorter:
                {
                    field: "name",
                    order: "asc"
                }
            },
            pagex:
            {
                current: 1,
                total: 0,
                pageSize: 1000000,
                sorter:
                {
                    field: "name",
                    order: "asc"
                }
            },
        inactives: [],
        weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        statesLoaded: false,
        loading: false,
        loadingOth: false,
        confirmLoading: false,
        site: { Id: '', name: '', stateCode: '', lga: '', siteId: '', state: '' },
        state: { id: 0, name: '', code: '', sites: [] },
            searchObj:
            {
                state: '',
                site: 0,
                siteName: '',
                stateName: ''
            }
    };

    async componentDidMount()
    {
        let el = this;
        let user = this.props.appUser;

        let sts = localStorage.getItem("states");
        let states = [];
        if (sts) states = JSON.parse(sts);

        let sites = [];
        if (user.stateCode && user.stateCode.length > 0) {
            var statex = states.filter(s => {
                return s.stateCode.toLocaleLowerCase() === user.stateCode.toLocaleLowerCase();
            });
            if (statex.length > 0) {
                let { searchObj } = this.state;
                let state: any = states[0];
                this.setState({ state, searchObj });
            }
        }

        let statesLoaded = true;
        this.setState({ states, statesLoaded });
    }
        
    selectSite(value: any) {
        const { searchObj } = this.state;
        if (value) {
            searchObj.site = value.key;
            let sites: any = this.state.sites.filter(function (o: any) { return o.siteId === searchObj.site });
            if (sites.length > 0) searchObj.siteName = sites[0].name;
            this.setState({ searchObj, sites });
        }
    }

    selectState(value: any) {
        var el = this;
        if (!value) {
            return;
        }
        const { searchObj } = this.state;
        searchObj.site = 0;
        if (value) {
            let val = value.key;
            let states = this.state.states.filter(function (s: any) { return s.stateId === val });
            if (states.length > 0) {
                var state = states[0];
                el.setState({ state: state, searchObj: searchObj });
            }
        }
    }

    handleTableChange(pagination: any, filters: any, sorter: any)
    {
        const pager = this.state.pagination;
        pager.current = pagination.current;

        this.setState({
            pagination: pager
        });
        this.getInactives({
            results: pager.pageSize,
            page: pager.current,
            sortField: pager.sorter.field,
            sortOrder: pager.sorter.order
        });
    }

    async getInactives(params: any)
    {
        let el = this;

        el.setState({ loading: true });
        var page = params.page;        
        var itemsPerPage = el.state.pagination.pageSize;

        el.setState({ loading: true });

        let res = await fetchData(`/api/Stats/getInactives?site=${el.state.searchObj.site}&itemsPerPage=${itemsPerPage}&pageNumber=${page}`);    

        const { pagination } = el.state;
        pagination.total = res.totalItems;
        el.setState({
            inactives: res.Trackers,
            pagination,
            loading: false
        });
    }

    async getLtfu(pointer: number = 1)
    {
        let el = this;

        if (el.state.searchObj.site === null || el.state.searchObj.site < 1)
        {
            message.error("Please select a Facility");
            return;
        }

        this.setState({ loading: true });

        el.setState({ loading: true });

        let trackers = await fetchData(`/api/Stats/getInactives?site=${el.state.searchObj.site}`);    
   
        if (trackers.length > 0)
        {
            el.setState({
                inactives: trackers
            });
        }

        var query = `/api/Stats/getLtfu?site=${el.state.searchObj.site}&pointer=${pointer}`;

        let res = await fetchData(query);

        if (pointer < 7) {
            if (pointer === 1) {
                el.setState({ ltfu1: res });
            }

            if (pointer === 2) {
                el.setState({ ltfu2: res });
            }

            if (pointer === 3)
                el.setState({ ltfu3: res });
            if (pointer === 4)
                el.setState({ ltfu4: res });
            if (pointer === 5)
                el.setState({ ltfu5: res });
            if (pointer === 6)
                el.setState({ ltfu6: res });
            if (pointer === 7)
                el.setState({ ltfu7: res });

            pointer += 1;
            el.state.loading = false;
            el.state.loadingOth = true;
            el.getLtfu(pointer)
        }
        else
        {
            el.setState({ ltfu7: res, loading: false, loadingOth: false });
        }
    }

    async exportData()
    {
        let el = this;

        if (el.state.searchObj.site === null || el.state.searchObj.site < 1)
        {
            message.error("Please select a Facility");
            return;
        }

        el.setState({ loading: true });
        let res = await fetchData(`/api/Stats/exportMissedAppointments?site=${el.state.searchObj.site}`);
        el.setState({ loading: false });
        if (res.code < 1)
        {
            message.error(res.message);
        }
        else
        {
            el.setState({ loading: true });
            var request = new XMLHttpRequest();
            request.open("GET", '/api/Stats/getMissedAppntsFile?baseF=' + res.asset + '&filename=' + res.fileName);
            request.responseType = "blob";
            request.onload = function ()
            {
                el.setState({ loading: false });
                var msie = window.navigator.userAgent.indexOf("MSIE");
                if (msie > 0)
                {
                    window.navigator.msSaveBlob(request.response, res.fileName);
                }
                else
                {
                    var url = window.URL.createObjectURL(request.response);
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.href = url;
                    a.download = request.response.fileName || res.fileName;
                    a.click();
                    a.remove();
                }
            }
            request.send();
        }
    }

    render()
    {        
        const inactiveColumns =
            [
                {
                    title: 'Patient Id',
                    dataIndex: 'patientId',
                    key: 'patientId',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Hospital Number',
                    dataIndex: 'hospitalNumber',
                    key: 'hospitalNumber',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Sex',
                    dataIndex: 'sex',
                    key: 'sex',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'ART Start Date',
                    dataIndex: 'artStartDate',
                    key: 'artStartDate',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Last Regimen',
                    dataIndex: 'lastRegimen',
                    key: 'lastRegimen',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Last Regimen Line',
                    dataIndex: 'lastRegimenLine',
                    key: 'lastRegimenLine',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Pickup Date',
                    dataIndex: 'lastDrugPickup',
                    key: 'lastDrugPickup',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Days Of ARV Refill',
                    dataIndex: 'lastDaysOfARVRefill',
                    key: 'lastDaysOfARVRefill',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Facility',
                    dataIndex: 'facility',
                    key: 'facility',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'LGA',
                    dataIndex: 'lga',
                    key: 'lga',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'State',
                    dataIndex: 'stateCode',
                    key: 'stateCode',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                }
            ];

        const columns =
            [
                {
                    title: 'State',
                    dataIndex: 'stateCode',
                    key: 'stateCode',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Facility',
                    dataIndex: 'facility',
                    key: 'facility',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Patient Id',
                    dataIndex: 'patientId',
                    key: 'patientId',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Hospital Number',
                    dataIndex: 'hospitalNumber',
                    key: 'hospitalNumber',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Sex',
                    dataIndex: 'sex',
                    key: 'sex',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Age',
                    dataIndex: 'age',
                    key: 'age',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'ART Start Date',
                    dataIndex: 'artStartDate',
                    key: 'artStartDate',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Last Regimen',
                    dataIndex: 'lastRegimen',
                    key: 'lastRegimen',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Last Regimen Line',
                    dataIndex: 'lastRegimenLine',
                    key: 'lastRegimenLine',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                 {
                     title: 'Last Pickup Date',
                     dataIndex: 'lastDrugPickup',
                     key: 'lastDrugPickup',
                     render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Last Days Of ARV Refill',
                    dataIndex: 'lastDaysOfARVRefill',
                    key: 'lastDaysOfARVRefill',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                }
        ];
     
        const { loading, loadingOth, state, states } = this.state;                      
        let user = this.props.appUser;

        const d = new Date();
        let day1 = d.getDay();

        d.setDate(d.getDate() + 1);
        let day2 = d.getDay();

        const d2 = new Date();
        d2.setDate(d2.getDate() + 2);
        let day3 = d2.getDay();

        const d3 = new Date();
        d3.setDate(d3.getDate() + 3);
        let day4 = d3.getDay();
            
        const d4 = new Date();
        d4.setDate(d4.getDate() + 4);
        let day5 = d4.getDay();
        
        const d5 = new Date();
        d5.setDate(d5.getDate() + 5);
        let day6 = d5.getDay();

        const d6 = new Date();
        d6.setDate(d6.getDate() + 6);
        let day7 = d6.getDay();

        let exportBtn = <Button type="default" className="dl-excel" style={{ borderRadius: 'none !important'}} onClick={() => this.exportData()} icon={<DownloadOutlined />}>
                            Export to Excel
                        </Button>

        return (
            <div className="site-top">
                <Helmet>
                    <title>CDR - Missed Appointments</title>
                </Helmet>
                <div className="custom-filter-dropdown">
                    <br/>
                    <Row style={{ marginTop: '2px' }}>
                        <Col span={24}>
                            <h4 style={{ fontWeight: 'bold', fontSize: '18px' }}>Missed Appointments</h4>
                        </Col>
                    </Row>
                    <br/>
                    <Row gutter={2}>
                        {!user.stateCode &&
                            <Col xs={24} sm={24} md={4} lg={4}>
                                <Select
                                labelInValue className="top-10-margin"
                                    showSearch
                                    optionFilterProp="children"
                                    disabled={loading}
                                    style={{ width: '98%' }}
                                    placeholder="Select State"
                                    onChange={(value) => this.selectState(value)}
                                >
                                    <Option key="" value="">-- Select State --</Option>
                                {states && states.map((s: any) => <Option key={s.stateId} value={s.stateId}>{s.stateName}</Option>)}
                                </Select>
                            </Col>
                        }
                        <Col xs={24} sm={24} md={6} lg={6}>
                            <Select className="top-10-margin"
                                labelInValue
                                showSearch
                                optionFilterProp="children"
                                disabled={loading}
                                style={{ width: "90% !important", float: "right" }}
                                placeholder="Select Facility"
                                onChange={(value) => this.selectSite(value)}
                            >
                                <Option key="" value="">-- Select Facility --</Option>
                                {state.sites && state.sites.map((s: any) => <Option key={s.id} value={s.id}>{s.name}</Option>)}
                            </Select>
                        </Col>
                        <Col xs={24} sm={24} md={4} lg={4}>
                            <Button disabled={loading} className="login-button top-10-margin" id="push-btn" loading={loading || loadingOth} key="submit" type="primary" size="large" onClick={() => this.getLtfu(1)} style={{ paddingRight: '40px', paddingLeft: '40px', float: 'right', width: '100%' }}>
                                <span id="buttonText">{!(loading && loadingOth) ? 'Fetch Data' : 'Processing...'}</span>
                            </Button>
                        </Col>
                    </Row>
                    <br />                    
                    <Row>
                        <Col span={24} className="ant-modal-footer si-ant">                           
                            <Tabs defaultActiveKey="1" > {/*tabBarExtraContent={exportBtn}*/}
                                <TabPane tab="Inactives ( > 28 days and <= 90 days)" key="1">
                                    <Row style={{ marginTop: '10px' }}>
                                        <Col span={24}>
                                            <Table columns={inactiveColumns} rowKey={(record: any) => record.patientId} pagination={this.state.pagination} dataSource={this.state.inactives} loading={loading} onChange={(a: any, b: any, c: any) => this.handleTableChange(a, b, c)} bordered />
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tab="IIT ( > 90 days)" key="2">
                                    <Row style={{ marginTop: '10px' }}>
                                        <Col span={24}>
                                            <h4 style={{ fontWeight: 'bold', fontSize: '18px', float: 'left' }}>Clients That will become IIT within a week time</h4>:: <span style={{ fontWeight: 'bold', float: 'left', marginLeft: '10px' }}>Starting from today</span>
                                        </Col>
                                    </Row>
                                    <br/>
                                    <Tabs defaultActiveKey="1">
                                        <TabPane tab={this.state.weekdays[day1]} key="1">
                                            <Row gutter={2}>
                                                <Col span={24} style={{ overflow: "scroll" }}>
                                                    <Table columns={columns} rowKey={(record: any) => record.patientId} dataSource={this.state.ltfu1} loading={loading} bordered />
                                                </Col>
                                            </Row>  
                                        </TabPane>
                                        <TabPane tab={this.state.weekdays[day2]} key="2">
                                            <Row gutter={2}>
                                                <Col span={24} style={{ overflow: "scroll" }}>
                                                    <Table columns={columns} rowKey={(record: any) => record.patientId} dataSource={this.state.ltfu2} loading={loading} bordered />
                                                </Col>
                                            </Row>  
                                        </TabPane>
                                        <TabPane tab={this.state.weekdays[day3]} key="3">
                                            <Row gutter={2}>
                                                <Col span={24} style={{ overflow: "scroll" }}>
                                                    <Table columns={columns} rowKey={(record: any) => record.patientId} dataSource={this.state.ltfu3} loading={loadingOth} bordered />
                                                </Col>
                                            </Row>  
                                        </TabPane>
                                        <TabPane tab={this.state.weekdays[day4]} key="4">
                                            <Row gutter={2}>
                                                <Col span={24} style={{ overflow: "scroll" }}>
                                                    <Table columns={columns} rowKey={(record: any) => record.patientId} dataSource={this.state.ltfu4} loading={loadingOth} bordered />
                                                </Col>
                                            </Row>  
                                        </TabPane>
                                        <TabPane tab={this.state.weekdays[day5]} key="5">
                                            <Row gutter={2}>
                                                <Col span={24} style={{ overflow: "scroll" }}>
                                                    <Table columns={columns} rowKey={(record: any) => record.patientId} dataSource={this.state.ltfu5} loading={loadingOth} bordered />
                                                </Col>
                                            </Row>  
                                        </TabPane>
                                        <TabPane tab={this.state.weekdays[day6]} key="6">
                                            <Row gutter={2}>
                                                <Col span={24} style={{ overflow: "scroll" }}>
                                                    <Table columns={columns} rowKey={(record: any) => record.patientId} dataSource={this.state.ltfu6} loading={loadingOth} bordered />
                                                </Col>
                                            </Row>  
                                        </TabPane>
                                        <TabPane tab={this.state.weekdays[day7]} key="7">
                                            <Row gutter={2}>
                                                <Col span={24} style={{ overflow: "scroll" }}>
                                                    <Table columns={columns} rowKey={(record: any) => record.patientId} dataSource={this.state.ltfu7} loading={loadingOth} bordered />
                                                </Col>
                                            </Row>  
                                        </TabPane>
                                    </Tabs>
                                </TabPane>
                            </Tabs>
                        </Col>
                    </Row>  

                </div>
            </div>
        )
    }
}

export default connect(
    (state: ApplicationState) => state.auth, // Selects which state properties are merged into the component's props
    AuthStore.actionCreators // Selects which action creators are merged into the component's props
)(MissedAppointment as any);
